
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useGlobalState } from '../../../../globalStates/ProfileThemeState';
const propTypes = {
    house: PropTypes.oneOf(['Hufflepuff', 'Ravenclaw', 'Slytherin', 'Gryffindor']).isRequired
};
const FirstLoadHouseText = ({ house }) => {
    const [houseName, setHouseName] = useState('Unknown');
    const [houseAnimationStarted] = useGlobalState('houseAnimationStarted');
    useEffect(() => {
        let timeout;
        if (houseAnimationStarted && houseName === 'Unknown') {
            timeout = setTimeout(() => {
                setHouseName(house);
            }, 250);
        }
        return () => clearTimeout(timeout);
    }, [house, houseAnimationStarted, houseName]);
    return <span>{houseName}</span>;
};
FirstLoadHouseText.propTypes = propTypes;
export default FirstLoadHouseText;

    async function __Next_Translate__getStaticProps__195ca0f167b__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//Profile/components/FirstLoadHouseText/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0f167b__ as getStaticProps }
  